import axios from "axios";
import { safeStorage } from "../utils/safeStorage";

// Sends an OTP for activating a digital voucher.
export const sendActivationOtp = async (coupon_code, coupon_id) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASEURL}/api/user/voucher/activation/otp/send`,
      { coupon_code, coupon_id },
      {
        headers: {
          "Content-Type": "application/json",
          "x-access-token": safeStorage.getItem("token"),
        },
      }
    );
    return response;
  } catch (err) {
    return err?.response || { data: { success: false, message: err.message } };
  }
};

// Verifies the OTP entered by the user for the voucher activation.
export const verifyActivationOtp = async (coupon_code, coupon_id, otp) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASEURL}/api/user/voucher/activation/otp/verify`,
      { coupon_code, coupon_id, otp: parseInt(`${otp}`, 10) },
      {
        headers: {
          "Content-Type": "application/json",
          "x-access-token": safeStorage.getItem("token"),
        },
      }
    );
    return response;
  } catch (err) {
    return err?.response || { data: { success: false, message: err.message } };
  }
};
